/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { TabBarBodyLayout } from '@veeam-vspc/shared/components';

import { ExtComponent } from '../../components/Ext/ExtComponent';

export const LicensingVeeamOnePage: React.FC<{}> = () => {
    const xtype = 'rcop.configuration.licensing.veeamOne';

    return (
        <TabBarBodyLayout>
            <ExtComponent
                xtype={xtype}
            />
        </TabBarBodyLayout>
    );
};
